import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import client from './client';
var apiBasePath = '/affiliation';
export var searchProducts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(search, site) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("".concat(apiBasePath, "/search"), {
              search: search,
              site: site
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function searchProducts(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getProduct = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lang, apiId, productId, site) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get("".concat(apiBasePath, "/product"), {
              lang: lang,
              apiId: apiId,
              productId: productId,
              site: site
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getProduct(_x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var createAffiliation = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(offerType, contentId, products) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.post("".concat(apiBasePath, "/affiliation"), {
              offerType: offerType,
              contentId: contentId,
              products: products
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function createAffiliation(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
export var updateAffiliation = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(affiliationId, offerType, contentId, products) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return client.put("".concat(apiBasePath, "/affiliation/").concat(affiliationId), {
              offerType: offerType,
              contentId: contentId,
              products: products
            });

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateAffiliation(_x10, _x11, _x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();
export var deleteAffiliation = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(affiliationId) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return client["delete"]("".concat(apiBasePath, "/affiliation/").concat(affiliationId));

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function deleteAffiliation(_x14) {
    return _ref5.apply(this, arguments);
  };
}();
export var getAffiliationProducts = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(lang, affiliationId, site) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return client.get("".concat(apiBasePath, "/products/").concat(affiliationId), {
              lang: lang,
              site: site
            });

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getAffiliationProducts(_x15, _x16, _x17) {
    return _ref6.apply(this, arguments);
  };
}();